module.exports = __webpack_public_path__ + "static/media/ic-arrowPagination.e59e1ab7.svg";